import { StyleSheet } from "aphrodite";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  accentColor,
  borderColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";

export interface IStyle {
  ul: any;
  list: any;
  link: any;
  span: any;
}

export const BreadcrumbStyle: IStyle = StyleSheet.create({
  ul: {
    listStyleType: "none",
    padding: `${space.atom} ${space.atom} ${space.atom0_5x}`,
  },
  list: {
    display: "inline-block",
    fontSize: fontSize.caption,
    lineHeight: lineHeight.caption3,
    color: textColor.primaryDarkColor,
    marginBottom: space.atom0_5x,
    ":after": {
      content: '"/"',
      color: borderColor.secondaryLightColor,
      padding: `0 ${space.atom}`,
      opacity: 0.7,
    },
    ":last-child": {
      ":after": {
        content: "none",
      },
    },
  },
  span: {
    color: textColor.secondaryDarkColor,
    textDecoration: "none",
  },
  link: {
    color: textColor.secondaryDarkColor,
    transition: "color 0.4s ease",
    ":hover": {
      color: accentColor.primaryColor,
    },
  },
});
